import { createLink } from "@tanstack/react-router"
import { Button } from "@motleyhand/design"
import type { ComponentProps } from "react"

const ButtonLink = createLink(
  ({ key, ...props }: ComponentProps<typeof Button>) => (
    <Button key={key} nativeButton={false} render={<a />} {...props} />
  ),
)

export default ButtonLink
